export default __webpack_public_path__ + "static/media/close-light.a1b03524.svg";